import { getTokens } from 'core/classes/helpers/StorageHelper'
import WebSocketStore from 'core/classes/services/WebSocketStore'
import { IFetchLandingResult } from 'partner360/models/landing/IFetchLandingResult'

interface IFetchLandingData {
  ownerId: string
}

export const fetchLandingData = async ({
  ownerId,
}: IFetchLandingData): Promise<IFetchLandingResult | null> => {
  const wsClient = WebSocketStore.get('partner360')
  const [token] = getTokens(ownerId)

  try {
    const res = await wsClient.call<IFetchLandingResult>({
      service: 'landing',
      action: 'fetch',
      payload: {},
      token: token || undefined,
      withoutTokenRefresh: true,
      isAuth: true,
    })
    return res.data
  } catch (e: any) {
    return null
  }
}
